exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app {\n  position: relative; }\n  .app .view-area {\n    max-height: 100vh;\n    min-height: calc(100vh - 72px);\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 72px 0 0;\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main